// extracted by mini-css-extract-plugin
export default {"InterventionsList":"InterventionsList_InterventionsList__HQ3Tc"};